import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static STEP_TO_EVENT_MAP = {
    'package_selection': 'add_to_cart',
    'request_date_time': 'begin_checkout',
    'personal_details': 'add_shipping_info',
    'safety_questions': 'add_payment_info'
  };

  static PACKAGE_MATRIX = {
    'full-body-mri-base': { sku: 'pid_1', anonymizedAdId: 'pid_a1b2c3d4e5f6g7h8', name: 'Base Scan', category: 'Full Body MRI' },
    'full-body-mri-plus': { sku: 'pid_2', anonymizedAdId: 'pid_f9e8d7c6b5a4b3c2', name: 'Plus Scan', category: 'Full Body MRI' },
    'full-body-mri-comprehensive': { sku: 'pid_3', anonymizedAdId: 'pid_1a2b3c4d5e6f7g8h', name: 'Comprehensive Scan', category: 'Full Body MRI' }
  };

  static values = { data: Object };

  trackPackageSelection(event) {
    const { packageSlug, price } = event.params;
    const packageData = this.constructor.PACKAGE_MATRIX[packageSlug];

    if (!packageData) return;

    const formattedPrice = this._formatPrice(price);

    const payload = {
      event: 'add_to_cart',
      ecommerce: {
        currency: 'GBP',
        value: formattedPrice,
        items: [{
          item_id: packageData.anonymizedAdId,
          item_name: packageData.name,
          item_sku: packageData.sku,
          item_category: packageData.category,
          price: formattedPrice,
          quantity: 1
        }]
      }
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    this.dispatch('step-processed', { target: window, detail: { step: 'package_selection', price: formattedPrice, packageSlug: packageSlug } });
  }

  trackStep(event) {
    const { step } = event.detail;
    const eventName = this.constructor.STEP_TO_EVENT_MAP[step];

    if (!eventName || !this.hasDataValue) return;

    const payload = this._buildPayload(step, eventName);
    if (!payload) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  _buildPayload(step, eventName) {
    const { packageSlug, price } = this.dataValue;
    const packageData = this.constructor.PACKAGE_MATRIX[packageSlug];

    if (!packageData) return null;

    const formattedPrice = this._formatPrice(price);

    this.dispatch('step-processed', { target: window, prefix: false, detail: { step: step, price: formattedPrice, packageSlug: packageSlug } });

    return {
      event: eventName,
      ecommerce: {
        currency: 'GBP',
        value: formattedPrice,
        items: [{
          item_id: packageData.anonymizedAdId,
          item_name: packageData.name,
          item_sku: packageData.sku,
          item_category: packageData.category,
          price: formattedPrice,
          quantity: 1
        }],
        step_name: step
      }
    };
  }

  _formatPrice(priceInCents) {
    if (priceInCents === null || priceInCents === undefined) {
      return 0.0;
    }
    return parseFloat(priceInCents);
  }
}
